import React, { useState, useEffect } from "react";
import { getPageTitle } from "../../common/CommonFunctions";
import { getUserRoleAndScreens } from "../../services/authServices/auth.services";
import { useSnackbar } from "../../contexts/Snackbar.context";
import { ERROR_MESSAGE, SNACKBAR_VARIANT } from "../../config/Messages.config";
import { getListOfAuditTypeCategories } from "../../helpers/api-functions-helper";
import { Divider, Grid2, Typography } from "@mui/material";
import MUITableSearch from "../../components/MUITable/MUITableSearch";
import AppButton from "../../components/CommonReusableComponent/AppButton/AppButton";
import AuditTypeCategoryDataTable_V2 from "./components/AuditTypeCategoryDataTable_V2";
import MUILoader from "../../components/MUILoader/MUILoader";
import CreateOrUpdateAuditTypeCategoryModal from "./components/CreateOrUpdateAuditTypeCategoryModal";
import { handleOutSideDataTableSearch } from "../../common/MuiTableFunctions.config";

const AuditTypeCategoryMaster = () => {
  const documentTitle = getPageTitle() && getPageTitle();
  document.title = documentTitle
    ? `${documentTitle} | Zing Auditor`
    : "Zing Auditor";
  const { showSnackbar } = useSnackbar();
  const { accountId } = getUserRoleAndScreens();
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [tableDataInstance, setTableDataInstance] = useState([]);
  const [tableData, setTableData] = useState([]);

  // Add or Update Category Modal
  const [addOrUpdateCategoryState, setAddOrUpdateCategoryState] = useState({
    data: null,
    isOpen: false,
  });

  // Function to handle category modal
  const handleCategoryModal = (data = null, isOpen = false) => {
    setAddOrUpdateCategoryState({ data, isOpen });
  };

  // search functionality
  const [searchText, setSearchText] = useState("");

  const fetchAllAuditTypeCategories = async () => {
    setIsPageLoading(true);
    try {
      const categoryRes = await getListOfAuditTypeCategories(accountId);
      const { statusCode, data, message } = categoryRes?.data;
      if (statusCode && statusCode === 200) {
        setTableDataInstance(data);
        setTableData(data);
      } else {
        showSnackbar(
          data || message || ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
          SNACKBAR_VARIANT.ERROR
        );
      }
    } catch (error) {
      console.log("Error: ", error);
      showSnackbar(ERROR_MESSAGE.FAILED_TO_FETCH_DATA, SNACKBAR_VARIANT.ERROR);
    } finally {
      setIsPageLoading(false);
    }
  };

  useEffect(() => {
    if (navigator.onLine) {
      fetchAllAuditTypeCategories();
    } else {
      showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Outside Table search functionality
  useEffect(() => {
    if (searchText === "") {
      // Reset to original data if search text is cleared
      setTableData(tableDataInstance);
    } else {
      const filteredData_ = handleOutSideDataTableSearch(
        searchText,
        tableDataInstance
      );
      setTableData(filteredData_);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  return (
    <React.Fragment>
      {addOrUpdateCategoryState?.isOpen && (
        <CreateOrUpdateAuditTypeCategoryModal
          DialogData={addOrUpdateCategoryState?.data}
          Open={addOrUpdateCategoryState?.isOpen}
          ToggleFunction={handleCategoryModal}
          FetchAllCategories={fetchAllAuditTypeCategories}
          ExistingCategoryNames={[...tableDataInstance].map((category) =>
            category.name.toLowerCase()
          )}
        />
      )}
      <div className="page-content">
        {isPageLoading ? (
          <MUILoader />
        ) : (
          <div>
            <Grid2
              container
              className="d-flex align-items-center my-1"
              spacing={2}
            >
              <Grid2 size={{ xs: 12, sm: 8, md: 10, lg: 10 }} className="py-1">
                <Typography className="inter-medium-500">
                  {documentTitle}
                </Typography>
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 4, md: 2, lg: 2 }} className="py-1">
                <AppButton OnPress={() => handleCategoryModal(null, true)}>
                  Create New Category
                </AppButton>
              </Grid2>
            </Grid2>

            <Divider
              style={{ color: "GrayText", border: "0.02rem solid GrayText" }}
              className="mt-2"
            />

            <Grid2 container className="my-2" spacing={2}>
              <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                <MUITableSearch
                  CancelSearch={() => {
                    setSearchText("");
                  }}
                  HandleSearch={(e) => setSearchText(e.target.value)}
                  SearchText={searchText}
                />
              </Grid2>
            </Grid2>

            <Grid2 container className="my-2">
              <Grid2 size={12}>
                <AuditTypeCategoryDataTable_V2
                  Rows={tableData || []}
                  GetRowDataOnClickOfAction={handleCategoryModal}
                />
              </Grid2>
            </Grid2>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default AuditTypeCategoryMaster;
